import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Solutions } from './pages/Solutions';
import { SampleAgenda } from './pages/SampleAgenda';
import { Venues } from './pages/Venues';
import { Packages } from './pages/Packages';
import { CaseStories } from './pages/CaseStories';
import { InsightHub } from './pages/InsightHub';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { ComebackPrograms } from './pages/ComebackPrograms';
import { BookingPage } from './pages/BookingPage';
import { ElevateImpact } from './pages/ElevateImpact';
import { TrainerPartnerProgram } from './pages/TrainerPartnerProgram';
import { VipPartnerProgram } from './pages/VipPartnerProgram';
import { DestaPass } from './pages/DestaPass';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
          <Route index element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="solutions" element={<Solutions data-id="element-8" />} data-id="element-7" />
          <Route path="agenda" element={<SampleAgenda data-id="element-10" />} data-id="element-9" />
          <Route path="venues" element={<Venues data-id="element-12" />} data-id="element-11" />
          <Route path="packages" element={<Packages data-id="element-14" />} data-id="element-13" />
          <Route path="comeback-programs" element={<ComebackPrograms data-id="element-16" />} data-id="element-15" />
          <Route path="booking" element={<BookingPage data-id="element-18" />} data-id="element-17" />
          <Route path="case-stories" element={<CaseStories data-id="element-20" />} data-id="element-19" />
          <Route path="insights" element={<InsightHub data-id="element-22" />} data-id="element-21" />
          <Route path="about" element={<About data-id="element-24" />} data-id="element-23" />
          <Route path="contact" element={<Contact data-id="element-26" />} data-id="element-25" />
          <Route path="elevate-impact" element={<ElevateImpact data-id="element-28" />} data-id="element-27" />
          <Route path="trainer-partner-program" element={<TrainerPartnerProgram data-id="element-30" />} data-id="element-29" />
          <Route path="vip-partner-program" element={<VipPartnerProgram data-id="element-32" />} data-id="element-31" />
          <Route path="destapass" element={<DestaPass data-id="element-34" />} data-id="element-33" />
        </Route>
      </Routes>
    </BrowserRouter>;
}